<div class="employee-profile-modal">
  <div class="employee-profile-modal__body">
    @if (profileView$ | async; as profileView) {
      <app-shared-profile [profile]="profileView.profile" [joinedAt]="profileView.joinedAt">
        <div sharedProfileSidebar class="employee-profile-modal__sidebar">
          @if (showDeleteButton && (canDeleteEmployee$ | async)) {
            <button
              type="button"
              class="employee-profile-modal__delete"
              [ngbTooltip]="'COMPONENTS.EMPLOYEE_PROFILE.REMOVE_TOOLTIP' | translate"
              [attr.aria-label]="'COMPONENTS.EMPLOYEE_PROFILE.REMOVE_TOOLTIP' | translate"
              (click)="deleteEmployee()"
            >
              <svg viewBox="0 0 18 20" fill="none" aria-hidden="true">
                <path
                  d="M7 16C7.26522 16 7.51957 15.8946 7.70711 15.7071C7.89464 15.5196 8 15.2652 8 15V9C8 8.73478 7.89464 8.48043 7.70711 8.29289C7.51957 8.10536 7.26522 8 7 8C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9V15C6 15.2652 6.10536 15.5196 6.29289 15.7071C6.48043 15.8946 6.73478 16 7 16ZM17 4H13V3C13 2.20435 12.6839 1.44129 12.1213 0.87868C11.5587 0.316071 10.7956 0 10 0H8C7.20435 0 6.44129 0.316071 5.87868 0.87868C5.31607 1.44129 5 2.20435 5 3V4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V6H17C17.2652 6 17.5196 5.89464 17.7071 5.70711C17.8946 5.51957 18 5.26522 18 5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4ZM7 3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V4H7V3ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V6H14V17ZM11 16C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9V15C10 15.2652 10.1054 15.5196 10.2929 15.7071C10.4804 15.8946 10.7348 16 11 16Z"
                  fill="currentColor"
                />
              </svg>
              <span>{{ "COMPONENTS.EMPLOYEE_PROFILE.REMOVE_BUTTON" | translate }}</span>
            </button>
          }
        </div>
      </app-shared-profile>
    }

    @if (formModel.form && showPermissions) {
      <section class="employee-profile-modal__permissions">
        <div class="employee-profile-modal__section-header">
          <h4>{{ "COMPONENTS.EMPLOYEE_PROFILE.PERMISSIONS" | translate }}</h4>
        </div>

        <form [formGroup]="formModel.form" class="employee-profile-modal__permissions-form">
          <div class="employee-profile-modal__permission-grid">
            @for (resourceType of orderedResourceTypes; track resourceType.value) {
              <section class="employee-profile-modal__permission-card">
                <h5>{{ resourceType.key | translate }}</h5>

                <div class="employee-profile-modal__permission-options">
                  @for (ctrl of resourceType.formArray.controls; track $index) {
                    @let checkboxId =
                      ctrl.controls.meta.value.permissionCode +
                      "" +
                      ctrl.controls.meta.value.resourceType;

                    @let labelText =
                      resourceType.value === resourceTypesEnum.Employee &&
                      ctrl.controls.meta.value.permissionCode ===
                        permissionsEnum.Edit
                        ? ("PERMISSIONS.MANAGE_USERS" | translate)
                        : ("PERMISSIONS." +
                            (ctrl.controls.meta.value.permissionCode
                              | enumKey: permissionsEnum
                              | snakeCase)!
                          | uppercase
                          | translate);

                    <app-checkbox
                      [id]="checkboxId"
                      [labelText]="labelText"
                      [formControl]="ctrl.controls.granted"
                      (change)="onToggle(ctrl)"
                    />
                  }
                </div>
              </section>
            }
          </div>
        </form>
      </section>
    }
  </div>
</div>
